import { useHealthyAuth } from 'lib/auth';
import { tracking } from 'lib/tracking';
import { reporter } from 'lib/reporter';
import useLogoutCleanups from './useLogoutCleanups';

export default function useLogout() {
  const { logout: authLogout } = useHealthyAuth();
  const cleanupFunctions = useLogoutCleanups();

  const logoutCleanups = () => {
    cleanupFunctions.forEach((cleanupFn) => {
      try {
        cleanupFn();
      } catch (error) {
        reporter.error(error, { context: 'Failed to run cleanup function' });
      }
    });
  };

  const logout = () => {
    logoutCleanups();
    tracking.trackEvent({ eventName: 'logout' });
    authLogout();
  };

  return { logout, logoutCleanups };
}
